import { ref as c, computed as y, onMounted as W, onBeforeUnmount as H, nextTick as P, withDirectives as U, createElementBlock as i, openBlock as s, createElementVNode as r, createCommentVNode as w, normalizeClass as d, renderSlot as x, toDisplayString as L, Fragment as $, renderList as z, createVNode as v, unref as m, withCtx as E, normalizeStyle as Y } from "vue";
import { useTracking as J } from "../../composables/useTracking.js";
/* empty css                   */
import O from "../../atoms/icon/icon-frame.vue.js";
import B from "../../atoms/icon-core/icon-core.vue.js";
import { resizeAwds as K } from "../../utils/directives/resize.js";
const Q = { class: "image-gallery" }, X = { class: "ds-grid ds-justify-content-space-between" }, Z = {
  key: 0,
  class: "ds-display-flex ds-flex-direction-column image-gallery__container__text-box__text"
}, ee = { class: "ds-grid__col ds-display-flex ds-justify-content-flex-end ds-align-items-flex-end" }, te = {
  key: 0,
  class: "image-gallery__container__dots"
}, ae = {
  key: 0,
  class: "image-gallery__container__button-group"
}, re = ["data-track-component-name", "data-track-title", "disabled"], ne = ["data-track-component-name", "data-track-title", "disabled"], le = { class: "ds-container" }, oe = { class: "ds-grid" }, ie = { class: "ds-full-screen-content ds-overflow-x-hidden" }, se = { class: "image-gallery__content-wrapper" }, de = {
  key: 0,
  class: "ds-container"
}, ce = { class: "ds-grid" }, ue = { class: "ds-grid__col" }, ke = /* @__PURE__ */ Object.assign({
  name: "DsImageGallery"
}, {
  __name: "image-gallery",
  props: {
    items: {
      type: Number,
      required: !0,
      validator: (e) => e > 0
    },
    width: {
      type: Object,
      required: !0,
      validator: (e) => ["small", "large"].every((b) => b in e)
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "primary",
      validator: (e) => ["primary", "secondary", "tertiary"].includes(e)
    },
    darkMode: {
      type: Boolean,
      default: !1
    },
    screen: {
      type: String,
      default: "small"
    }
  },
  emits: ["item-clicked"],
  setup(e) {
    const { provideTrackingData: b } = J(), D = {
      primary: [
        { control: "arrows", screen: "large" },
        { control: "arrows", screen: "medium" },
        { control: "dots", screen: "small" }
      ],
      secondary: [
        { control: "dots", screen: "large" },
        { control: "dots", screen: "medium" },
        { control: "dots", screen: "small" }
      ],
      tertiary: [
        { control: "", screen: "large" },
        { control: "dots", screen: "medium" },
        { control: "dots", screen: "small" }
      ]
    }, F = K(), l = e, k = c(0), u = c("0px"), g = c(null), h = c(), _ = c(), f = c(), n = c({
      left: !1,
      right: !1
    }), I = y(() => D[l.type].find((a) => a.screen === l.screen)), p = y(() => I.value.control === "dots"), A = y(() => I.value.control === "arrows"), N = y(() => {
      var t;
      return l.screen === "large" ? `${l.width.large}px` : l.screen === "medium" ? (t = l.width) != null && t.medium ? `${l.width.medium}px` : `${l.width.large}px` : `${l.width.small}px`;
    });
    W(() => {
      G();
    }), H(() => {
      M();
    });
    const V = () => {
      if (!h.value)
        u.value = "0px";
      else {
        const t = typeof window < "u" ? getComputedStyle(h.value).marginLeft : "0px";
        u.value = t === "auto" ? "0px" : t;
      }
    };
    function j() {
      g.value && f.value.forEach((t) => {
        g.value.observe(t);
      });
    }
    const R = () => {
      if (typeof window > "u")
        return;
      M();
      const t = {
        root: _.value,
        threshold: 0.9
      };
      u.value && u.value !== "0px" && u.value.includes("px") && (t.rootMargin = `0px -${u.value}`), g.value = new IntersectionObserver(q, t), j();
    };
    function M() {
      g.value && g.value.disconnect();
    }
    function q(t) {
      t.forEach((a) => {
        a.isIntersecting && (k.value = S(a.target)), C(a.target, "FIRST") ? n.value.left = !a.isIntersecting : C(a.target, "LAST") && (n.value.right = !a.isIntersecting);
      });
    }
    function S(t) {
      if (!t)
        return;
      const a = t.classList.value.split("item-")[1];
      if (a)
        return parseInt(a);
    }
    function C(t, a) {
      if (!["FIRST", "LAST"].includes(a))
        return !1;
      const o = a === "FIRST" ? 1 : l.items;
      return S(t) === o;
    }
    function T(t) {
      if (!f.value)
        return;
      const a = f.value[0].offsetWidth;
      t === 1 ? n.value.right && _.value.scrollBy({ left: a, behavior: "smooth" }) : t === -1 && n.value.left && _.value.scrollBy({ left: 0 - a, behavior: "smooth" });
    }
    async function G() {
      V(), await P(), R();
    }
    return b({ "component-name": "DsImageGallery", title: l.title }), (t, a) => U((s(), i("div", Q, [
      r("div", {
        ref_key: "imageGalleryOuterContainer",
        ref: h,
        class: d(["ds-container image-gallery__container", [
          {
            "ds-margin-bottom-48": e.title || e.description || p.value && e.items > 1 || n.value.left || n.value.right || A.value
          }
        ]])
      }, [
        r("div", X, [
          r("div", {
            class: d(["ds-grid__col ds-grid__col--10 image-gallery__container__text-box", { "ds-margin-bottom-24": (e.title || e.description) && p.value }])
          }, [
            e.title || e.description ? (s(), i("div", Z, [
              r("h2", {
                class: d(["ds-heading", { "ds-color-white": e.darkMode }])
              }, L(e.title), 3),
              e.description ? (s(), i("p", {
                key: 0,
                class: d(["ds-text ds-margin-top-12", { "ds-color-white": e.darkMode }])
              }, L(e.description), 3)) : w("", !0)
            ])) : x(t.$slots, "default", { key: 1 })
          ], 2),
          r("div", ee, [
            p.value && e.items > 1 ? (s(), i("div", te, [
              (s(!0), i($, null, z(e.items, (o) => (s(), i("span", {
                key: o,
                class: d(["image-gallery__container__dots__dot", {
                  "image-gallery__container__dots__dot--active": o === k.value && !e.darkMode,
                  "image-gallery__container__dots__dot--active--dark": o === k.value && e.darkMode,
                  "image-gallery__container__dots__dot--dark": e.darkMode
                }])
              }, null, 2))), 128))
            ])) : (s(), i($, { key: 1 }, [
              n.value.left || n.value.right ? (s(), i("div", ae, [
                r("button", {
                  "data-track-text": "arrow-left",
                  "data-track-component-name": t.$options.name,
                  "data-track-title": e.title,
                  class: d([{
                    "image-gallery__container__button-group__button--disabled": !n.value.left && !e.darkMode,
                    "image-gallery__container__button-group__button--disabled--dark": !n.value.left && e.darkMode,
                    "image-gallery__container__button-group__button--dark": e.darkMode
                  }, "image-gallery__container__button-group__button image-gallery__button-group__button--left ds-button-link ds-button-link--primary ds-button-link--black-green"]),
                  disabled: !n.value.left,
                  type: "button",
                  onClick: a[0] || (a[0] = (o) => [T(-1), t.$emit("item-clicked", { label: "arrow-left" })])
                }, [
                  v(m(O), {
                    size: "24",
                    "align-y": "center"
                  }, {
                    default: E(() => [
                      v(m(B), {
                        category: "arrows",
                        name: "chevron-left"
                      })
                    ]),
                    _: 1
                  })
                ], 10, re),
                r("button", {
                  "data-track-text": "arrow-right",
                  "data-track-component-name": t.$options.name,
                  "data-track-title": e.title,
                  class: d([{
                    "image-gallery__container__button-group__button--disabled": !n.value.right && !e.darkMode,
                    "image-gallery__container__button-group__button--disabled--dark": !n.value.right && e.darkMode,
                    "image-gallery__container__button-group__button--dark": e.darkMode
                  }, "image-gallery__container__button-group__button image-gallery__button-group__button--right ds-button-link ds-button-link--primary ds-button-link--black-green"]),
                  disabled: !n.value.right,
                  type: "button",
                  onClick: a[1] || (a[1] = (o) => [T(1), t.$emit("item-clicked", { label: "arrow-right" })])
                }, [
                  v(m(O), {
                    size: "24",
                    "align-y": "center"
                  }, {
                    default: E(() => [
                      v(m(B), {
                        category: "arrows",
                        name: "chevron-right"
                      })
                    ]),
                    _: 1
                  })
                ], 10, ne)
              ])) : w("", !0)
            ], 64))
          ])
        ])
      ], 2),
      r("div", le, [
        r("div", oe, [
          r("div", ie, [
            r("div", se, [
              r("ul", {
                ref_key: "imageGalleryContainer",
                ref: _,
                class: "image-gallery__content-wrapper__content ds-scrollbar-hidden"
              }, [
                (s(!0), i($, null, z(e.items, (o) => (s(), i("li", {
                  key: o,
                  ref_for: !0,
                  ref_key: "imageGalleryItem",
                  ref: f,
                  class: d(["image-gallery__content-wrapper__content__item", `image-gallery__content-wrapper__content__item-${o}`])
                }, [
                  r("div", {
                    style: Y({ width: N.value }),
                    class: "ds-height-full"
                  }, [
                    x(t.$slots, "default", { index: o })
                  ], 4)
                ], 2))), 128))
              ], 512)
            ])
          ])
        ])
      ]),
      t.$slots["image-gallery-footer"] ? (s(), i("div", de, [
        r("div", ce, [
          r("div", ue, [
            x(t.$slots, "image-gallery-footer")
          ])
        ])
      ])) : w("", !0)
    ])), [
      [m(F), G]
    ]);
  }
});
export {
  ke as default
};
